import { z } from 'zod';

export const Branded_app_jobsScalarFieldEnumSchema = z.enum(['id','step','site_name','mode','platform','app_version','job_status','retry_count','last_error_message','run_at','job_id','data','created_at','updated_at']);

export default Branded_app_jobsScalarFieldEnumSchema;
